import { Slide } from "../../components/Carousel/carouselContents";
import hereBoyLogin from "../../assets/images/hereBoyLogIn.png";
import hereBoyHome from "../../assets/images/hereBoyHome.png";
import hereBoyResult from "../../assets/images/hereBoyResult.png";

export const hereBoyCarouselContents: Slide[] = [
  {
    cImg: `${hereBoyLogin}`,
    cAlt: "Screenshot of the Login page from https://hereboycodechallenge.netlify.app/",
  },
  {
    cImg: `${hereBoyHome}`,
    cAlt: "Screenshot of the Home page from https://hereboycodechallenge.netlify.app/",
  },
  {
    cImg: `${hereBoyResult}`,
    cAlt: "Screenshot of the Match Dog Result Pop Up from https://hereboycodechallenge.netlify.app/",
  },
];
